import React from 'react';
import { authProtectedRoutes } from 'helpers/customNavigationRules';
import PropTypes from 'prop-types';

import MenuListItem from './MenuListItem';

const MenuList = ({ activeItem = null, menuItems, onSelectMenuItem }) => (
  <div className="menu">
    {menuItems.map(
      ({ altIcon, icon, iconType, isSupportIcon, link, name, noLink, onClick, subpages }) => {
        return (
          <MenuListItem
            activeItem={activeItem}
            altIcon={altIcon}
            authRequired={authProtectedRoutes.includes(link)}
            icon={icon}
            iconType={iconType}
            isSupportIcon={isSupportIcon}
            key={name}
            link={link}
            name={name}
            noLink={noLink}
            onClick={onClick || onSelectMenuItem}
            subpages={subpages}
          />
        );
      },
    )}
  </div>
);

MenuList.propTypes = {
  activeItem: PropTypes.string,
  menuItems: PropTypes.array.isRequired,
  onSelectMenuItem: PropTypes.func.isRequired,
};

export default MenuList;
